import React from 'react'
import { createSelector } from 'reselect'
import { useSelector, shallowEqual } from 'react-redux'

import { Typography } from '@material-ui/core'
import ButtonBuyOnline from './ButtonBuyOnline'
import useEcommerce from './Ecommerce/useEcommerce'
import searchAlertIcon from '~/assets/icons/search-alert.svg'
import { selectPosition } from '../selectors'
import { useLiterals } from '~/components/Literals'

const selector = createSelector(
  (state) => state.app.currentProduct,
  (state) => state.config,
  (product, config) => ({ product, config }),
)

const StoreNotFound = () => {
  const { product, config } = useSelector(selector, shallowEqual)

  const { getLiteral } = useLiterals()
  const { openEcommerce, setOpenEcommerce, dataEcommerce, loadingEcommerce, setApiEcommerce } = useEcommerce()
  const { buyOnline, showBuyOnline, showContextViewEstablishment = false, textProductNotFound = '' } = config

  const [position] = useSelector(selectPosition, shallowEqual)

  const enabledBuyOnline = Boolean(showBuyOnline)
  const isIncludeBuyOnline = ['fixedLink', 'googleShopping', 'ecommerceGoogle'].includes(buyOnline)

  return (
    <>
      <img src={searchAlertIcon} alt={getLiteral('2340')} style={{ marginBottom: 16, marginTop: 8 }} />

      <Typography variant="body1" style={{ fontSize: 16 }} gutterBottom align="center">
        {showContextViewEstablishment
          ? getLiteral('2534')
          : isIncludeBuyOnline && enabledBuyOnline
            ? `${textProductNotFound || getLiteral('2341')}`
            : `${textProductNotFound || getLiteral('2342')}`}
      </Typography>

      {!showContextViewEstablishment && isIncludeBuyOnline && enabledBuyOnline && (
        <Typography variant="body1" style={{ fontSize: 14 }} gutterBottom align="center">
          {getLiteral('2343')}:
        </Typography>
      )}

      {!showContextViewEstablishment && isIncludeBuyOnline && enabledBuyOnline && (
        <div style={{ marginTop: 8 }}>
          <ButtonBuyOnline
            modal
            secondary
            product={product}
            position={position}
            dataEcommerce={dataEcommerce}
            openEcommerce={openEcommerce}
            setOpenEcommerce={setOpenEcommerce}
            loadingEcommerce={loadingEcommerce}
            setApiEcommerce={setApiEcommerce}
          />
        </div>
      )}
    </>
  )
}

export default StoreNotFound
